import { memoize } from 'lodash-es';

import { isServer } from './isServer';

function _isIos() {
  if (isServer()) {
    return false;
  }

  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}

export const isIos = memoize(_isIos);
